import {
  Component, Input, OnChanges, OnInit
} from '@angular/core';
import {CommonModule, NgStyle} from "@angular/common";
import {Fonts} from "@white-label/components/white-label/font-selectbox/font-selectbox.component";
import GraphemeSplitter from 'grapheme-splitter';
import emojiRegexFactory from 'emoji-regex';
export class TypographyPreviewModel {
  shadowX = 2;
  shadowY = 2;
  shadowZ = 2;
  shadowColor = '#000';
  spaceBetween = 2;
  lineHeight = 1;
  animation = "tada";
  font = "Roboto Condensed";
  fontSize= 20;
  color = 'linear-gradient(0deg, #feb602, #f59c07)';
  isItalic = false;
  isBold = true;
  isUnderline = false;
}


export enum AnimationsEnum {
  Bounce = 'bounce',
  Bounce2 = 'bounce2',
  Pulse = 'pulse',
  Pulse2 = 'pulse2',
  Rubber = 'rubber',
  Rubber2 = 'rubber2',
  Shake = 'shake',
  Shake2 = 'shake2',
  Swipes = 'swipes',
  Swipes2 = 'swipes2',
  TADA = 'tada',
  TADA2 = 'tada2',
  Wag = 'wag',
  Wag2 = 'wag2',
  Gale = 'gale',
  Gale2 = 'gale2'
}
export const AnimationDelays = {
  [AnimationsEnum.Gale2]: 0.1,
  [AnimationsEnum.Gale]: 0,
  [AnimationsEnum.Bounce]: 0,
  [AnimationsEnum.Bounce2]: 0.1,
  [AnimationsEnum.Pulse]: 0,
  [AnimationsEnum.Pulse2]: 0.1,
  [AnimationsEnum.Rubber]: 0,
  [AnimationsEnum.Rubber2]: 0.1,
  [AnimationsEnum.Shake]: 0,
  [AnimationsEnum.Shake2]: 0.1,
  [AnimationsEnum.Swipes]: 0,
  [AnimationsEnum.Swipes2]: 0.1,
  [AnimationsEnum.TADA]: 0,
  [AnimationsEnum.TADA2]: 0.1,
  [AnimationsEnum.Wag]: 0,
  [AnimationsEnum.Wag2]: 0.1
}


@Component({
  selector: 'white-label-typography-preview',
  templateUrl: './typography-preview.component.html',
  standalone: true,
  imports: [
    NgStyle,
    CommonModule
  ],
  providers: [],
  styleUrls: ['./typography-preview.component.scss']
})
export class TypographyPreviewComponent implements OnInit{
  @Input() design: TypographyPreviewModel = new TypographyPreviewModel();
  animations = AnimationDelays;
  @Input() text?: any = '';
  emojiRegex = emojiRegexFactory();

  @Input() metrica?: any = 'px';
  delay: number = this.animations[this.design.animation]
  // An array of characters from the text
  textArray: any[] = [];

  constructor() { }

  ngOnInit(): void {
    if(!this.design?.fontSize){
      this.design.fontSize = 24;
    }
    if(!this.design?.shadowX){
      this.design.shadowX = 1;
    }
    if(!this.design?.shadowY){
      this.design.shadowY = 1;
    }
    if(!this.design?.shadowZ){
      this.design.shadowZ = 1;
    }
    if(!this.design?.shadowColor){
      this.design.shadowColor = '#000';
    }
    if(!this.design?.spaceBetween){
      this.design.spaceBetween = 1;
    }
    if(!this.design?.lineHeight){
      this.design.lineHeight = 2;
    }
    if(!this.design?.animation){
      this.design.animation = AnimationsEnum.Pulse;
    }
    if(!this.design?.font){
      this.design.font =  Fonts.Exo2;
    }
    if(!this.design?.color){
      this.design.color = '#fff';
    }
    if(this.text){
      const splitter = new GraphemeSplitter();
      this.textArray = splitter.splitGraphemes(this?.text)

    }

  }
  isEmoji(char: string): boolean {
    this.emojiRegex.lastIndex = 0;
    return this.emojiRegex.test(char);
  }


  protected readonly Math = Math;
}
